import React, {Fragment} from 'react';
import Navbar2 from '../../components/Navbar2';
import Hero5 from '../../components/hero5';
import CoupleSection from '../../components/CoupleSection';
import PortfolioSection from '../../components/PortfolioSection';
import RSVP from '../../components/RSVP';
import CtaSection2 from '../../components/CtaSection2';
import Scrollbar from '../../components/scrollbar'
import Logo from "../../images/zsofi_es_peti_eskuvoje_logo_white.png";
import Footer from '../../components/footer';
import EventSection from '../../components/EventSection';
import SzallasokSection from '../../components/SzallasokSection';



const HomePage5 =() => {

    return(
        <Fragment>
            <Navbar2 Logo={Logo} topbarNone={'topbarNone'} hclass={'wpo-header-style-3'}/>
            <Hero5/>
            <CoupleSection cClass={'pt-160'}/>
            <CtaSection2/>
            <EventSection/>
            <SzallasokSection/>
            <RSVP/>
            <PortfolioSection/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};

export default HomePage5;